import type { Config } from '@/widgets/Wizard/models/config';
import {
    CheckInPinPaymentStep,
    ExtrasStep,
    HtmlPageStep,
    LanguageSelectStep,
    PersonalDetailsStep,
    PetsStep,
    PickAccommodationObjectStep,
    PickAccommodationStep,
    PinPaymentStep,
    IdealCheckoutStep,
    ReceiptConfirmStep,
    ReceiptStep,
    CheckInReservationNumberStep,
    StayDurationStep,
    ThanksStep,
    TravelGroupStep,
    CheckInThanksStep,
} from '@/widgets/Wizard/modules/steps';
import type { Button, Text } from '@/widgets/Wizard/models/markup';
import { accessTranslation } from '@/widgets/Wizard/modules/wizard-translations';
import type { Step } from '@/widgets/Wizard/models/step';
import { CampingLaPinedePinPaymentStepOverride, UiterwaardePersonalDetailsStep, UiterwaardeReceiptConfirmStepOverride } from '@/widgets/Wizard/modules/steps.override';

export const defaultConfig: Config = createDefaultConfig();
export const tacozijlConfig: Config = createDefaultConfig(['nl', 'en', 'de']);
export const campingLaPinedeConfig: Config = {
    flows: {
        default: {
            title: '',
            hasProgressBar: true,
            childOf: null,
            steps: [
                new LanguageSelectStep(['nl', 'en', 'de', 'fr'], 'book.start'),
                new HtmlPageStep([
                    { code: 'text', type: 'title', translation: 'intro.title' } as Text,
                    { code: 'text', type: 'paragraph', translation: 'intro.par1' } as Text,
                    { code: 'text', type: 'paragraph', translation: 'intro.par2', translationConfig: () => ({ website_url: accessTranslation('account.website') }) } as Text,
                    { code: 'text', type: 'paragraph', translation: 'intro.par3', translationConfig: () => ({ website_url: accessTranslation('account.website') }) } as Text,
                    { code: 'button', action: 'next', translation: 'intro.start' } as Button,
                ]),
                new TravelGroupStep(),
                new PetsStep(),
                new StayDurationStep(),
                new PickAccommodationStep(),
                new PickAccommodationObjectStep(),
                new ExtrasStep(),
                new ReceiptStep(),
                new PersonalDetailsStep(),
                new ReceiptConfirmStep(),
                new CampingLaPinedePinPaymentStepOverride(),
                new ThanksStep(),
            ],
        },
    },
};
export const uiterwaardeConfig: Config = {
    flows: {
        default: {
            title: '',
            hasProgressBar: true,
            childOf: null,
            steps: [
                new UiterwaardePersonalDetailsStep(),
                new UiterwaardeReceiptConfirmStepOverride(),
                new IdealCheckoutStep(),
            ],
        },
    },
};

function createDefaultConfig(languages: string[] = ['nl', 'en', 'de', 'fr', 'it', 'es', 'pt']): Config {
    return {
        flows: {
            default: {
                title: '',
                hasProgressBar: true,
                childOf: null,
                steps: [
                    new LanguageSelectStep(languages, 'book.start'),
                    new HtmlPageStep([
                        { code: 'text', type: 'title', translation: 'intro.title' } as Text,
                        { code: 'text', type: 'paragraph', translation: 'intro.par1' } as Text,
                        { code: 'text', type: 'paragraph', translation: 'intro.par2', translationConfig: () => ({ website_url: accessTranslation('account.website') }) } as Text,
                        { code: 'button', action: 'next', translation: 'intro.start' } as Button,
                        { code: 'text', type: 'subtitle', translation: 'intro.subtitle' } as Text,
                        { code: 'text', type: 'paragraph', translation: 'intro.par3', translationConfig: () => ({ website_url: accessTranslation('account.website') }) } as Text,
                    ]),
                    ...bookFlow(),
                ],
            },
        },
    };
}

function bookFlow(): Step[] {
    return [
        new TravelGroupStep(),
        new PetsStep(),
        new StayDurationStep(),
        new PickAccommodationStep(),
        new PickAccommodationObjectStep(),
        new ExtrasStep(),
        new ReceiptStep(),
        new PersonalDetailsStep(),
        new ReceiptConfirmStep(),
        new PinPaymentStep(),
        new ThanksStep(),
    ];
}

function existingBookingFlow(): Step[] {
    return [
        new CheckInReservationNumberStep(),
        new CheckInPinPaymentStep(),
        new CheckInThanksStep(),
    ];
}
